import type { Row, RowData, Table } from '@tanstack/react-table';
import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import type { TableAction } from './types';

export interface DataProviderContext<TData extends RowData> {
  table?: Table<TData>;
  actions: TableAction[];
  toolbarControls?: ReactNode;
  getRowCount: () => number;
  isLoading: boolean;
  isRowIndeterminate?: (row: Row<TData>) => boolean;
  isRowHighlighted?: (row: Row<TData>) => boolean;
  isRowClickable?: (row: Row<TData>) => boolean;
  onRowClick?: (row: Row<TData>) => void;
  id?: string;
}

export const Context = createContext<DataProviderContext<any>>({
  actions: [],
  getRowCount: () => 0,
  isLoading: false,
});

export const useDataProvider = () => useContext(Context);
